import React from 'react';
import { ApiDocCategory, ApiDocEndpoint } from '@/types/ApiDocs.ts';
import { cn } from '@/lib/utils.ts';
import { ChevronDown, ChevronLeft } from 'lucide-react';
import { DynIcon } from './shared.tsx';
import { METHOD_COLORS } from '../utils.ts';

interface CategoryNavProps {
    category: ApiDocCategory;
    collapsed: boolean;
    onToggle: () => void;
    selectedEndpointId?: number;
    onSelectEndpoint: (ep: ApiDocEndpoint) => void;
}

export function CategoryNav({
    category,
    collapsed,
    onToggle,
    selectedEndpointId,
    onSelectEndpoint,
}: CategoryNavProps) {
    return (
        <div>
            <button
                onClick={onToggle}
                className="w-full flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
            >
                <DynIcon name={category.icon} className="size-4 text-gray-500 shrink-0" />
                <span className="flex-1 text-right truncate">{category.name}</span>
                <span className="text-xs text-gray-400">{category.endpoints.length}</span>
                {collapsed
                    ? <ChevronLeft className="size-3.5 text-gray-400" />
                    : <ChevronDown className="size-3.5 text-gray-400" />}
            </button>
            {!collapsed && (
                <div className="pb-1">
                    {category.endpoints.map((ep) => (
                        <button
                            key={ep.id}
                            onClick={() => onSelectEndpoint(ep)}
                            className={cn(
                                'w-full flex items-center gap-2 pr-9 pl-4 py-1.5 text-xs transition-colors text-right',
                                selectedEndpointId === ep.id
                                    ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-500'
                                    : 'text-gray-600 hover:bg-gray-50',
                            )}
                        >
                            <span
                                className={cn(
                                    'shrink-0 text-[9px] font-bold px-1 py-0.5 rounded border',
                                    METHOD_COLORS[ep.method],
                                )}
                            >
                                {ep.method.slice(0, 3)}
                            </span>
                            <span className="truncate flex-1">{ep.name}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
